import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EFrequency, ISavedSearch } from '../../../types/savedSearch';
import { TThunkDispatch } from '../../../types/redux';
import { unsubscribeFromSearch } from '../../../thunk/savedSearches/unsubscribeFromSearch';
import { subscribeToSavedSearch } from '../../../thunk/savedSearches/subscribeToSavedSearch';
import { changeFrequencySavedSearch } from '../../../thunk/savedSearches/changeFrequencySavedSearch';
import { selectUser } from '../../../selectors';
import { SavedSearchesList } from '../../../components/SavedSearches/DesktopComponents/SavedSearchesList';
import { selectIsEmailConfirmed } from '../../../selectors/user/selectIsEmailConfirmed';
import { deleteSavedSearches } from '../../../thunk/savedSearches/deleteSavedSearches';

interface IDesktopSavedSearchesProps {
  searches: ISavedSearch[];
}

export const DesktopSavedSearches: React.FC<IDesktopSavedSearchesProps> = ({ searches }) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const user = useSelector(selectUser);
  const isEmailConfirmed = useSelector(selectIsEmailConfirmed);

  const onFrequencyChange = React.useCallback(
    (frequency: EFrequency | null, id: number) => {
      const search = searches.find(s => s.id === id) as ISavedSearch;

      if (frequency) {
        if (search.status === 'active') {
          dispatch(changeFrequencySavedSearch({ id, frequency }));
        } else {
          dispatch(subscribeToSavedSearch({ id, frequency, email: user.isAuthenticated ? user.email : '' }));
        }
      } else {
        dispatch(unsubscribeFromSearch({ id }));
      }
    },
    [dispatch],
  );

  const onSearchRemove = React.useCallback(
    (id: number) => {
      dispatch(deleteSavedSearches(id));
    },
    [dispatch],
  );

  return (
    <SavedSearchesList
      data={searches}
      isEmailConfirmed={isEmailConfirmed}
      onSearchRemove={onSearchRemove}
      onFrequencyChange={onFrequencyChange}
    />
  );
};
